// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectedBalanceSheets_wrapper__Gxcro"};